var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopyIcon = function SvgCopyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6236842,0 L1.96052632,0 C1.07473684,0 0.35,0.736363636 0.35,1.63636364 L0.35,13.0909091 L1.96052632,13.0909091 L1.96052632,1.63636364 L11.6236842,1.63636364 L11.6236842,0 Z M14.0394737,3.27272727 L5.18157895,3.27272727 C4.29578947,3.27272727 3.57105263,4.00909091 3.57105263,4.90909091 L3.57105263,16.3636364 C3.57105263,17.2636364 4.29578947,18 5.18157895,18 L14.0394737,18 C14.9252632,18 15.65,17.2636364 15.65,16.3636364 L15.65,4.90909091 C15.65,4.00909091 14.9252632,3.27272727 14.0394737,3.27272727 Z M14.0394737,16.3636364 L5.18157895,16.3636364 L5.18157895,4.90909091 L14.0394737,4.90909091 L14.0394737,16.3636364 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03-Meeting-History-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Meeting-History-/-Details-/-Delivery",
    transform: "translate(-661.000000, -574.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(330.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(20.000000, 430.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Item-/-Icon-/-30",
    transform: "translate(304.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF10-Icon",
    transform: "translate(7.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-2)",
    fill: "#CACFD3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 0.000000)",
    id: "\\uD83C\\uDFA8-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18
  })))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy-icon.89128b3e.svg";
export { ForwardRef as ReactComponent };